import styled from 'styled-components';
import { colors } from '../../theme/modules/colors';
import { Text } from '../Text';
import { BaseContainer } from '../BaseContainer';
import { sizes } from '../../theme/modules/sizes';
const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--1vyyfhh" }) `padding:14px 24px;`;
const CounterText = styled(Text).withConfig({ displayName: "vui--CounterText", componentId: "vui--ycgtn6" }) `line-height:1;`;
const Contour = styled(BaseContainer).withConfig({ displayName: "vui--Contour", componentId: "vui--zy3oaf" }) `position:relative;display:flex;flex-direction:row;align-items:center;height:40px;border-radius:4px;padding:0 12px;border:1px solid transparent;cursor:pointer;${({ colourPalette, customTextColour }) => `
    &:hover {
      border: 1px solid ${colourPalette.base};
      background-color: ${colourPalette.lightest};
    }

    ${Text} {
      color: ${customTextColour !== null && customTextColour !== void 0 ? customTextColour : colors.neutral.ink.dark};
    }
  `} ${({ active, colourPalette }) => active &&
    `
    background-color: ${colourPalette.lightest};
  `}`;
const CounterContainer = styled(Text).withConfig({ displayName: "vui--CounterContainer", componentId: "vui--chq9kr" }) `display:inline-flex;flex-direction:row;justify-content:center;align-items:center;border-radius:4px;padding:2px 4px;min-width:20px;height:20px;margin-left:8px;${({ active, colourPalette }) => active &&
    `
    background-color: ${colourPalette.base};

    & > ${CounterText} {
      color: #fff;
    }
  `}`;
const IconStyling = {
    style: {
        marginLeft: sizes.xs,
        padding: sizes.xs,
        height: sizes.base,
        width: sizes.base,
    },
};
export const CustomIconWrapper = styled.div.withConfig({ displayName: "vui--CustomIconWrapper", componentId: "vui--yu7dwm" }) `display:flex;align-items:center;margin-right:${sizes.sm};svg{height:${sizes.base};width:${sizes.base};}`;
export { Container, Contour, Text, CounterContainer, CounterText, IconStyling };
//# sourceMappingURL=styled.js.map